/**
 * Frases de erro das etapas de produtos e prontuário. O servidor recusa com uma frase em português
 * (`error`/`message`) e um `code`; arquivo grande ou de tipo errado ganha aqui o que fazer a seguir.
 */

interface RespostaDeErro {
  response?: { data?: { code?: unknown; error?: unknown; message?: unknown } };
  message?: unknown;
}

const FRASE_POR_CODIGO: Readonly<Record<string, string>> = {
  FILE_TOO_LARGE:
    'O arquivo passa de 9 MB. Reduza o tamanho (por exemplo, exporte o PDF em menor qualidade) e envie de novo.',
  INVALID_FILE: 'Esse arquivo não serve. Envie um PDF, PNG ou JPEG de até 9 MB.',
};

const comoTexto = (valor: unknown): string | null =>
  typeof valor === 'string' && valor.trim() !== '' ? valor : null;

/** A frase que a pessoa lê quando algo é recusado ou falha: a do código, a do servidor ou a de reserva. */
export const mensagemDoServidor = (err: unknown, fallback: string): string => {
  if (typeof err !== 'object' || err === null) return fallback;
  const { response, message } = err as RespostaDeErro;
  const codigo = comoTexto(response?.data?.code);
  if (codigo && FRASE_POR_CODIGO[codigo]) return FRASE_POR_CODIGO[codigo];
  return comoTexto(response?.data?.error) ?? comoTexto(response?.data?.message) ?? comoTexto(message) ?? fallback;
};
